module.exports = __webpack_public_path__ + "static/media/ic_pay_visa.b970a526.svg";